import { Directive, OnInit } from '@angular/core';
import { IfStandaloneDirective } from './if-standalone.directive';

@Directive({
    selector: '[ifNotStandalone]'
})
export class IfNotStandaloneDirective extends IfStandaloneDirective implements OnInit {
    override ngOnInit() {
        this.ngIf = !this.pwaIntegrationService.isStandalone;
    }
}
